import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/reset.css'
import './styles/variables.css'
import './index.css'
import '@rockstar/registration-component/dist/index.cjs.css'
import App from './App'

import { ControlModalProvider } from '@rockstar/registration-component'
import { TimerProvider } from './shared/utils/context/TimerContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <ControlModalProvider>
            <TimerProvider>
                <App />
            </TimerProvider>
        </ControlModalProvider>
    </React.StrictMode>,
)
